import { CardHeader, Grid, TextField, Typography, Box, useMediaQuery, Divider, lighten, useTheme } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { platformServicesMasterActions } from '../../store/reducers/platform-master';
import Styles from '../../theme/commonCss/Styles';
import CheckboxComponent from '../../components/Checkbox';
import Ajv from 'ajv';
import AjvErrors from 'ajv-errors';
import { addPlatformUISchema, addPlatformSchema } from './form';
import get from 'lodash/get';
import FormModal from '../../common/formModal';
import reduce from 'lodash/reduce';
import { useOutletContext } from 'react-router-dom';

const AddPlatform = ({
  isOpen,
  serviceData,
  isEdit,
  handleChange = () => { },
  onCheckItem = () => { },
  handleClose = () => { },
  setServiceData
}: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const validate = ajv.compile(addPlatformSchema);
  const [ajvErrors, setAjvErrors] = useState<any>({});

  const responsiveSize = useMediaQuery('(max-width:900px)');

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const trimmedServiceData = reduce(
      serviceData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );
    setServiceData(trimmedServiceData);

    if (validate({ ...trimmedServiceData })) {
      if (isEdit) {
        dispatch(platformServicesMasterActions.updateServiceRequest(trimmedServiceData));
      } else {
        dispatch(platformServicesMasterActions.addServiceRequest(trimmedServiceData));
      }
      handleClose();
      setAjvErrors({});
    } else {
      if (validate.errors) {
        // console.log(validate.errors[0])
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  const renderFields = () => (
    <Grid container spacing={2} sx={{ ...Styles.gridContainer, flexDirection: 'column' , marginLeft: 0}}>
      {addPlatformUISchema.map(({ label, name, type, options, required }: any) => {
        if (type === 'input') {
          return (
            <Grid container key={name} sx={{ display: 'flex', marginBlock: '12px' }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{
                  display: 'flex',
                  justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                  p: responsiveSize ? '0 0 4px' : '10px 0 0',
                }}
              >
                <Typography sx={{...Styles.inputLabel, color: themeData.palette.text.primary}} className={required ? 'required-field' : ''}>
                  {label}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={8}>
                <TextField
                  type={name === 'port' ? 'number' : 'text'}
                  margin='normal'
                  fullWidth
                  id={name}
                  onChange={handleChange}
                  name={name}
                  autoComplete={name}
                  variant='outlined'
                  value={serviceData[name]}
                  size='small'
                  sx={{ margin: 0 }}
                  helperText={get(ajvErrors, 'instancePath', '').includes(name) && ajvErrors.message}
                  error={get(ajvErrors, 'instancePath', '').includes(name)}
                />
              </Grid>
            </Grid>
          );
        } else if (type === 'select') {
          return (
            <Box
              key={name}
              sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBlock: '12px' }}
            >
              <Box sx={{ display: 'flex' }}>
                <Grid item xs={4} sx={Styles.gridItem}>
                  <Typography sx={Styles.inputLabel} className={required ? 'required-field' : ''}>
                    Types
                  </Typography>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                  {options.map((option: string, index: number) => (
                    <Box key={option} sx={{ mr: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <CheckboxComponent
                        key={option + index}
                        handleCheckboxChange={(event: any) => onCheckItem(event, option)}
                        checked={serviceData.types != null ? serviceData.types.includes(option) : false}
                      />
                      <Typography variant='body2'>{option}</Typography>
                    </Box>
                  ))}
                </Grid>
              </Box>
              {ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && (
                <Box sx={{ display: 'flex' }}>
                  <Grid item xs={4} sx={Styles.gridItem}></Grid>
                  <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant='body2' color='error' sx={{ textAlign: 'center' }}>
                      {ajvErrors.message}
                    </Typography>
                  </Grid>
                </Box>
              )}
            </Box>
          );
        } else {
          return <></>;
        }
      })}
    </Grid>
  );

  return (
    <FormModal title={isEdit ? 'EDIT SERVICE' : 'ADD NEW SERVICE'} isOpen={isOpen} handleSubmit={handleSubmit} handleClose={handleClose}>
      <CardHeader title='Services Definition'  />
      <Divider />
      {renderFields()}
    </FormModal>
  );
};

export default AddPlatform;
